exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1bpOEQcDbEVOLumfhLJqry{position:relative}._1bpOEQcDbEVOLumfhLJqry ._35tbB8TDIxZHuNSMmaZmbS{text-align:center;max-width:500px;margin:0 auto}\n", ""]);

// Exports
exports.locals = {
	"OtherFlow": "_1bpOEQcDbEVOLumfhLJqry",
	"instructions": "_35tbB8TDIxZHuNSMmaZmbS"
};